import { ServiceIdForMember } from '@/constants';
import { SxClassProps } from '@/types/common';

const ABOVE_THE_FOLD_IMAGE_STYLES: { [key: string]: SxClassProps } = Object.freeze({
  [ServiceIdForMember.SENIOR_CARE]: {
    backgroundPosition: {
      xs: 'center',
    },
  },
  [ServiceIdForMember.PET_CARE]: {
    backgroundPosition: {
      xs: 'center',
      md: '60% 50%',
      lg: 'center',
    },
  },
  [ServiceIdForMember.HOUSEKEEPING]: {
    backgroundPosition: {
      xs: 'center',
      md: '60% 50%',
      lg: 'center',
    },
  },
  [ServiceIdForMember.TUTORING]: {
    backgroundPosition: {
      xs: 'center',
    },
  },
  [ServiceIdForMember.SPECIAL_NEEDS]: {
    backgroundPosition: {
      xs: 'center',
      md: '60% 50%',
      lg: 'center',
    },
  },
  [ServiceIdForMember.CARE_GIGS]: {
    backgroundPosition: {
      xs: 'center',
      md: '60% 50%',
      lg: 'center',
    },
  },
  [ServiceIdForMember.CHILD_CARE]: {
    backgroundPosition: {
      xs: 'center',
      lg: '40% 50%',
    },
  },
  newborn: {
    backgroundPosition: {
      xs: 'center',
      lg: '40% 50%',
    },
  },
  petCareCat: {
    backgroundPosition: {
      xs: 'center',
      lg: '35% 50%',
    },
  },
  petCareBird: {
    backgroundPosition: {
      xs: 'center',
      md: '60% 50%',
      lg: 'center',
    },
  },
});

const getHeroImageStyles = (seoSegmentId: string, serviceIdForMember: string): SxClassProps => {
  // separate the segment from the rest of the url (e.g. /child-care/boston-ma -> /child-care)
  const segment = `/${seoSegmentId.split('/')[1]}`;

  const segmentationsWithCatImage = [
    '/cat-sitters',
    '/cat-groomers',
    '/cat-boarding',
    '/cat-trainers',
  ];

  const segmentationsWithNewbornImage = [
    '/newborn-nannies',
    '/infant-nannies',
    '/infant-child-care',
    '/infant-babysitters',
    '/night-nannies',
    '/infant-daycare',
  ];

  if (
    serviceIdForMember === ServiceIdForMember.BABYSITTER ||
    serviceIdForMember === ServiceIdForMember.NANNY
  ) {
    return ABOVE_THE_FOLD_IMAGE_STYLES[ServiceIdForMember.CHILD_CARE];
  }

  if (serviceIdForMember === ServiceIdForMember.TUTORING_AFTER_SCHOOL_CARE) {
    return ABOVE_THE_FOLD_IMAGE_STYLES[ServiceIdForMember.TUTORING];
  }

  if (serviceIdForMember === ServiceIdForMember.PET_DAY_CARE_LOCATION) {
    return ABOVE_THE_FOLD_IMAGE_STYLES[ServiceIdForMember.PET_CARE];
  }

  if (segmentationsWithCatImage.includes(segment)) {
    return ABOVE_THE_FOLD_IMAGE_STYLES.petCareCat;
  }

  if (segment.includes('/bird-sitters')) {
    return ABOVE_THE_FOLD_IMAGE_STYLES.petCareBird;
  }

  if (segmentationsWithNewbornImage.includes(segment)) {
    return ABOVE_THE_FOLD_IMAGE_STYLES.newborn;
  }

  // default image style to child care if no match
  return (
    ABOVE_THE_FOLD_IMAGE_STYLES[serviceIdForMember] ||
    ABOVE_THE_FOLD_IMAGE_STYLES[ServiceIdForMember.CHILD_CARE]
  );
};

export { getHeroImageStyles, ABOVE_THE_FOLD_IMAGE_STYLES };
